import { render, staticRenderFns } from "./QuesCard.vue?vue&type=template&id=0c6246cc&"
import script from "./QuesCard.vue?vue&type=script&lang=js&"
export * from "./QuesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports